import {swalFire} from "../../../plugins/sweet-alert/sweet-alert-default";

export default function pointsPackageScript($page) {
    const $pointsCount = $('#points_package\\.count');
    const $priceEur = $('#points_package\\.price_eur');
    const $priceUsd = $('#points_package\\.price_usd');
    const $pricePln = $('#points_package\\.price_pln');
    const pricePerStatementEur = $("#pricePerStatementEur").val();
    const pricePerStatementUsd = $("#pricePerStatementUsd").val();
    const pricePerStatementPln = $("#pricePerStatementPln").val();
    let unlimitedStatus = $('#points_package\\.unlimited').prop('checked');

    $page
        .on('change', $pointsCount, calculateDischargeAmount)
        .on('change', $priceEur, calculateDischargeAmount)
        .on('change', $priceUsd, calculateDischargeAmount)
        .on('change', $pricePln, calculateDischargeAmount)
        .on('change', '#points_package\\.unlimited', checkUnlimited);

    function calculateDischargeAmount() {
        const count = $pointsCount.val();

        // EUR
        const regularPriceEur = pricePerStatementEur * count;
        const discountEur = regularPriceEur - $priceEur.val();
        $('.pointsPackageDischargeAmount').text(discountEur.toFixed(2));

        // USD
        if (pricePerStatementUsd && $priceUsd.val()) {
            const regularPriceUsd = pricePerStatementUsd * count;
            const discountUsd = regularPriceUsd - $priceUsd.val();
            $('.pointsPackageDischargeAmountUsd').text(discountUsd.toFixed(2));
        } else {
            $('.pointsPackageDischargeAmountUsd').text('0.00');
        }

        // PLN
        if (pricePerStatementPln && $pricePln.val()) {
            const regularPricePln = pricePerStatementPln * count;
            const discountPln = regularPricePln - $pricePln.val();
            $('.pointsPackageDischargeAmountPln').text(discountPln.toFixed(2));
        } else {
            $('.pointsPackageDischargeAmountPln').text('0.00');
        }
    }

    function checkUnlimited() {
        unlimitedStatus = $('#points_package\\.unlimited').prop('checked');
        $pointsCount.prop('disabled', unlimitedStatus);
        if (unlimitedStatus) $pointsCount.val(1000000);
    }

    calculateDischargeAmount();
    checkUnlimited();

    $page.on('click', '.preventSubmit', function (event) {
        event.preventDefault();

        const $form = $(this).closest('form');
        const $selectAllContainer = $form.find('#selectAllContainer');
        const dataTable = $('.table.dataTable').DataTable();
        const selectedRows = dataTable.rows(function (idx, data, node) {
            let cells = $(node).find('input[type="checkbox"]');
            return checkedTargets(cells).length;
        })
            .data()

        $selectAllContainer.html('');
        selectedRows.each(function (row) {
            let checkbox = $(row[0]).find('input[type=checkbox]');
            checkbox.attr('value', '1');
            checkbox.attr('type', 'hidden');
            checkbox.attr('class', '');
            $selectAllContainer.append(checkbox);
        })

        const eurPrice = Number($priceEur.val());
        const anyPriceZero = !Number.isFinite(eurPrice) || eurPrice === 0;

        if (anyPriceZero) {
            swalFire({
                title: 'Achtung!!! The package price is 0',
                text: 'Do you really want to set the point pack price to zero?',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                cancelButtonIcon: 'arrow-back',
                confirmButtonText: 'Yes, save',
                confirmButtonIcon: 'check',
                confirmButtonColor: '#34C391',
            }).then((result) => {
                if (result.isConfirmed) {
                    $(this).closest('form').submit();
                    return false;
                }
            });
        } else {
            $(this).closest('form').submit();
            return false;
        }

        return false;
    });

    function checkedTargets(checkboxes) {
        return checkboxes.filter(function (index) {
            return $(checkboxes[index]).prop('checked');
        });
    }

    $('#special_offer').on('change', function (e) {
        $('.special_offer').slideToggle();
        $('.special_offer input').prop('disabled', !e.target.checked);
    });
}
